"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSettlementSettingsComplete = exports.getMissingSettlementSettingsFields = exports.isDistributionSettingsComplete = exports.getMissingDistributionSettingsFields = exports.DISTRIBUTION_SETTINGS_FIELD_LABELS = void 0;
const constants_1 = require("../constants");
const enums_1 = require("./enums");
exports.DISTRIBUTION_SETTINGS_FIELD_LABELS = {
    allowReinvestment: "Allow reinvestment",
    roundingMethod: "Default rounding method",
    apcaId: "APCA ID",
    settlementBsb: "Settlement BSB",
    settlementAccountNumber: "Settlement Account Number",
    fiCode: "FI Code",
    taxResidencyCountryCode: "Fund tax residency country",
    investorTreatment: "Default investor treatment",
};
const roundingMethodValues = new Set(Object.values(enums_1.RoundingMethod));
const investorTreatmentValues = new Set(Object.values(enums_1.InvestorTreatment));
const isValidRoundingMethod = (value) => Boolean(value?.trim() && roundingMethodValues.has(value.trim()));
const isValidApcaId = (value) => Boolean(value?.trim() && /^\d{6}$/.test(value.trim()));
const isValidSettlementBsb = (value) => Boolean(value?.trim() && /^\d{3}-\d{3}$/.test(value.trim()));
const isValidSettlementAccountNumber = (value) => Boolean(value?.trim() && /^\d{6,9}$/.test(value.trim()));
const isValidFiCode = (value) => Boolean(value?.trim() && /^[A-Za-z0-9]{2,3}$/.test(value.trim()));
const isValidTaxResidencyCountryCode = (value) => {
    const code = value?.trim().toUpperCase();
    return Boolean(code && code.length === 3 && constants_1.COUNTRY_ALPHA3_CODES.has(code));
};
const isValidInvestorTreatment = (value) => Boolean(value?.trim() && investorTreatmentValues.has(value.trim()));
/**
 * User-facing labels for fields that are unset or fail DistributionSettingsSchema-equivalent rules.
 * Excludes settlement bank details (settlementBsb, settlementAccountNumber, fiCode) — those are only
 * required at ABA generation time, not for creating or confirming a distribution.
 */
const getMissingDistributionSettingsFields = (config) => {
    const missing = [];
    if (config?.allowReinvestment === undefined || config?.allowReinvestment === null) {
        missing.push(exports.DISTRIBUTION_SETTINGS_FIELD_LABELS.allowReinvestment);
    }
    if (!isValidRoundingMethod(config?.roundingMethod)) {
        missing.push(exports.DISTRIBUTION_SETTINGS_FIELD_LABELS.roundingMethod);
    }
    if (!isValidApcaId(config?.apcaId)) {
        missing.push(exports.DISTRIBUTION_SETTINGS_FIELD_LABELS.apcaId);
    }
    if (!isValidTaxResidencyCountryCode(config?.taxResidencyCountryCode)) {
        missing.push(exports.DISTRIBUTION_SETTINGS_FIELD_LABELS.taxResidencyCountryCode);
    }
    if (!isValidInvestorTreatment(config?.investorTreatment)) {
        missing.push(exports.DISTRIBUTION_SETTINGS_FIELD_LABELS.investorTreatment);
    }
    return missing;
};
exports.getMissingDistributionSettingsFields = getMissingDistributionSettingsFields;
const isDistributionSettingsComplete = (config) => (0, exports.getMissingDistributionSettingsFields)(config).length === 0;
exports.isDistributionSettingsComplete = isDistributionSettingsComplete;
/** User-facing labels for settlement bank fields that are unset or invalid — required only at ABA generation time. */
const getMissingSettlementSettingsFields = (config) => {
    const missing = [];
    if (!isValidSettlementBsb(config?.settlementBsb)) {
        missing.push(exports.DISTRIBUTION_SETTINGS_FIELD_LABELS.settlementBsb);
    }
    if (!isValidSettlementAccountNumber(config?.settlementAccountNumber)) {
        missing.push(exports.DISTRIBUTION_SETTINGS_FIELD_LABELS.settlementAccountNumber);
    }
    if (!isValidFiCode(config?.fiCode)) {
        missing.push(exports.DISTRIBUTION_SETTINGS_FIELD_LABELS.fiCode);
    }
    return missing;
};
exports.getMissingSettlementSettingsFields = getMissingSettlementSettingsFields;
const isSettlementSettingsComplete = (config) => (0, exports.getMissingSettlementSettingsFields)(config).length === 0;
exports.isSettlementSettingsComplete = isSettlementSettingsComplete;
//# sourceMappingURL=IDistributionConfig.js.map